'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _moment2 = require('@alicd/next/lib/moment');

var _moment3 = _interopRequireDefault(_moment2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _datePicker = require('@alicd/next/lib/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cruiFormItem = require('@alicd/crui-form-item');

var _cruiFormItem2 = _interopRequireDefault(_cruiFormItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RangePicker = _datePicker2.default.RangePicker;

var RangePickerField = function (_React$Component) {
  (0, _inherits3.default)(RangePickerField, _React$Component);

  function RangePickerField() {
    (0, _classCallCheck3.default)(this, RangePickerField);
    return (0, _possibleConstructorReturn3.default)(this, (RangePickerField.__proto__ || (0, _getPrototypeOf2.default)(RangePickerField)).apply(this, arguments));
  }

  (0, _createClass3.default)(RangePickerField, [{
    key: 'render',
    value: function render() {
      /* eslint-disable */
      var _props = this.props,
          bind = _props.bind,
          style = _props.style,
          inputStyle = _props.inputStyle,
          init = _props.init,
          other = (0, _objectWithoutProperties3.default)(_props, ['bind', 'style', 'inputStyle', 'init']);
      var labelCol = other.labelCol,
          wrapperCol = other.wrapperCol,
          mapping = other.mapping,
          className = other.className,
          otherInput = (0, _objectWithoutProperties3.default)(other, ['labelCol', 'wrapperCol', 'mapping', 'className']);
      /* eslint-enable */

      var format = 'YYYY-MM-DD';
      if (this.props.showTime) {
        format += ' HH:mm:ss';
      }

      if (init && init.value) {
        init.value = [(0, _moment3.default)(init.value[0]).format(this.props.format || format), (0, _moment3.default)(init.value[1]).format(this.props.format || format)];
      }

      return _react2.default.createElement(
        _cruiFormItem2.default,
        (0, _extends3.default)({}, other, { style: style }),
        _react2.default.createElement(RangePicker, (0, _extends3.default)({}, otherInput, { style: inputStyle }))
      );
    }
  }]);
  return RangePickerField;
}(_react2.default.Component);

exports.default = RangePickerField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-range-picker-field@0.0.9@@alicd/crui-range-picker-field/lib/index.js
// module id = 656
// module chunks = 0